import { createStyles, makeStyles, Theme, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import React, { forwardRef, Ref, useContext } from "react";
import { Field, FieldProps, Form } from "react-final-form";
import { OutputType } from "../treeBlockOutputsDataSource";
import { treeBlockConfigurations, treeBlockOutputsContext } from "../schema";
import { TreeBlockType } from "../TreeBlockType";

interface OutputLabelProps {
  ellipsis?: boolean;
  treeBlockType: TreeBlockType;
  outputType: OutputType;
  value: any;
  label: string | (() => string);
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    portName: {
      display: "flex",
      alignItems: "center",
      padding: "3px"
    },
    portNameEllipsis: {
      maxWidth: "100px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    }
  })
);

export const OutputLabel = observer((props: OutputLabelProps) => {
  return (
    <Tooltip title={<OutputLabelRenderer {...props} />}>
      <div>
        <OutputLabelRenderer ellipsis={true} {...props} />
      </div>
    </Tooltip>
  );
});

export const OutputLabelRenderer = forwardRef(
  (props: OutputLabelProps, ref: Ref<any>) => {
    const { label, value, outputType, treeBlockType, ellipsis } = props;
    const preparedLabel = typeof label == "function" ? label() : label;
    const classes = useStyles();
    const outputContext = useContext(treeBlockOutputsContext);
    return (
      <div
        ref={ref}
        className={clsx(classes.portName, ellipsis && classes.portNameEllipsis)}
      >
        {treeBlockConfigurations[treeBlockType].outputFormSchema &&
        outputContext.requiresForeignKeyRendering(outputType) ? (
          <Form onSubmit={() => {}}>
            {() => {
              // @ts-ignore
              return treeBlockConfigurations[
                treeBlockType
              ].outputFormSchema.mapFields(
                (field: any) => {
                  return (
                    <Field
                      {...({
                        name: field.name,
                        meta: {},
                        key: field.name,
                        input: {
                          value: value
                        },
                        component: field.type.PresentationComponent,
                        ...field.type.props
                      } as FieldProps<any, any>)}
                    />
                  );
                },
                { data: { type: outputType } }
              );
            }}
          </Form>
        ) : (
          <span>{preparedLabel}</span>
        )}
      </div>
    );
  }
);
